import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import APIProviderTable from '../../../components/tables/APIProviderTable';

const APIProviderList = () => {
  // Sample data generator for API Providers
  const generateSampleData = (count = 25) => {
    const serviceTypes = ['Recharge', 'Bill Payment', 'Money Transfer', 'AEPS', 'Pan Card', 'Fastag', 'DMT', 'BBPS', 'Insurance'];
    const statuses = ['Active', 'Inactive'];
    const providerTypes = ['Online', 'Offline'];
    const providers = [
      'PaySprint', 'FinoBank', 'RazorPay', 'PayTM', 'PhonePe', 'Cyrus', 'Roundpay',
      'Recharge1', 'MPL', 'EKO', 'BillAvenue', 'BBPS Central', 'Spice Money', 'Fino Payments',
      'InstaPay', 'ExpressPay', 'Eko India', 'Vayana Network', 'PayNearby'
    ];
    
    const credentialTemplates = [
      'API_KEY: {key}\nAPI_SECRET: {secret}',
      'Token: {token}\nClient_ID: {clientId}',
      'Username: {username}\nPassword: {password}\nAPI_KEY: {key}',
      'Bearer Token: {token}\nMerchant_ID: {merchantId}'
    ];
    
    return Array.from({ length: count }, (_, i) => {
      const serviceName = serviceTypes[Math.floor(Math.random() * serviceTypes.length)];
      const providerName = providers[Math.floor(Math.random() * providers.length)];
      const template = credentialTemplates[Math.floor(Math.random() * credentialTemplates.length)];
      
      return {
        id: `API${String(i + 1).padStart(4, '0')}`,
        serviceName: serviceName,
        providerName: providerName,
        providerType: providerTypes[Math.floor(Math.random() * providerTypes.length)],
        status: statuses[Math.floor(Math.random() * statuses.length)],
        credentials: template
          .replace('{key}', Math.random().toString(36).substring(2, 18).toUpperCase())
          .replace('{secret}', Math.random().toString(36).substring(2, 18).toUpperCase())
          .replace('{token}', Math.random().toString(36).substring(2, 25).toUpperCase())
          .replace('{clientId}', `CLIENT_${Math.random().toString(36).substring(2, 12).toUpperCase()}`)
          .replace('{username}', `user_${providerName.toLowerCase().replace(/\s+/g, '_')}`)
          .replace('{password}', Math.random().toString(36).substring(2, 15))
          .replace('{merchantId}', `MERCH_${Math.random().toString(36).substring(2, 12).toUpperCase()}`)
      };
    });
  };

  // Initialize API Provider data with state
  const [apiProviders, setApiProviders] = useState(generateSampleData(25));

  // Handle data change (add/edit provider)
  const handleDataChange = (newData) => {
    setApiProviders(newData);
  };

  return (
    <Container fluid className="">
      <APIProviderTable
        data={apiProviders}
        onDataChange={handleDataChange}
      />
    </Container>
  );
};

export default APIProviderList;

